import { object } from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectors as userSelectors } from 'modules/user';
import { configContainsSku } from 'utils/configurations';

import { ZOOM_CHAT } from './constants';

const ZoomChat = ({ userConfiguration }) => {
    const hasZoomChatSku = configContainsSku(userConfiguration, ZOOM_CHAT.SKU);

    useEffect(() => {
        if (
            !hasZoomChatSku ||
            !ZOOM_CHAT.API_KEY ||
            document.querySelector(`#${ZOOM_CHAT.SCRIPT_ID}`)
        ) {
            return;
        }

        const script = document.createElement('script');
        script.id = ZOOM_CHAT.SCRIPT_ID;
        script.type = 'module';
        script.src = ZOOM_CHAT.SDK_URL;
        script.setAttribute('data-apikey', ZOOM_CHAT.API_KEY);
        script.setAttribute('data-env', ZOOM_CHAT.REGION);
        document.body.appendChild(script);

        // eslint-disable-next-line consistent-return
        return () => {
            const el = document.querySelector(`#${ZOOM_CHAT.SCRIPT_ID}`);
            if (el) el.remove();
        };
    }, [hasZoomChatSku]);

    return null;
};

const mapStateToProps = createStructuredSelector({
    userConfiguration: userSelectors.getUserConfiguration,
});

ZoomChat.propTypes = {
    userConfiguration: object.isRequired,
};

export { ZoomChat as ZoomChatUnwrapped };
export default connect(mapStateToProps)(ZoomChat);
